var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnlyRefund(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u83DC\u5355icon/\u4EC5\u9000\u6B3E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u83DC\\u5355icon/\\u4EC5\\u9000\\u6B3E",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u652F\\u51FA"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "currentColor",
    fillRule: "nonzero",
    opacity: 0,
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.671875,9.490625 L6.3375,9.490625 C5.98125,9.490625 5.6921875,9.2015625 5.6921875,8.8453125 C5.6921875,8.4890625 5.98125,8.2 6.3375,8.2 L9.671875,8.2 C10.028125,8.2 10.3171875,8.4890625 10.3171875,8.8453125 C10.3171875,9.2015625 10.028125,9.490625 9.671875,9.490625 Z",
    id: "\\u8DEF\\u5F84",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0046875,11.0265625 C7.6484375,11.0265625 7.359375,10.7375 7.359375,10.38125 L7.359375,8.8125 C7.359375,8.45625 7.6484375,8.1671875 8.0046875,8.1671875 C8.3609375,8.1671875 8.65,8.45625 8.65,8.8125 L8.65,10.38125 C8.65,10.7375 8.3609375,11.0265625 8.0046875,11.0265625 L8.0046875,11.0265625 Z",
    id: "\\u8DEF\\u5F84",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.7546875,8.784375 C7.5890625,8.784375 7.425,8.721875 7.2984375,8.5953125 L6.2234375,7.5203125 C5.971875,7.26875 5.971875,6.859375 6.2234375,6.6078125 C6.475,6.35625 6.884375,6.35625 7.1359375,6.6078125 L8.2109375,7.6828125 C8.4625,7.934375 8.4625,8.34375 8.2109375,8.5953125 C8.0859375,8.721875 7.9203125,8.784375 7.7546875,8.784375 Z",
    id: "\\u8DEF\\u5F84",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2296875,8.784375 C8.0640625,8.784375 7.9,8.721875 7.7734375,8.5953125 C7.521875,8.34375 7.521875,7.934375 7.7734375,7.6828125 L8.8203125,6.6359375 C9.071875,6.384375 9.48125,6.384375 9.7328125,6.6359375 C9.984375,6.8875 9.984375,7.296875 9.7328125,7.5484375 L8.6859375,8.5953125 C8.559375,8.721875 8.39375,8.784375 8.2296875,8.784375 L8.2296875,8.784375 Z",
    id: "\\u8DEF\\u5F84",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0046875,14.440625 C4.446875,14.440625 1.5515625,11.5453125 1.5515625,7.9875 C1.5515625,4.4296875 4.446875,1.534375 8.0046875,1.534375 C8.3609375,1.534375 8.65,1.8234375 8.65,2.1796875 C8.65,2.5359375 8.3609375,2.825 8.0046875,2.825 C5.1578125,2.825 2.8421875,5.140625 2.8421875,7.9875 C2.8421875,10.834375 5.1578125,13.15 8.0046875,13.15 C10.8515625,13.15 13.1671875,10.834375 13.1671875,7.9875 C13.1671875,7.6390625 13.13125,7.2890625 13.0625,6.9484375 C12.990625,6.5984375 13.2171875,6.2578125 13.565625,6.1875 C13.915625,6.1171875 14.25625,6.3421875 14.3265625,6.690625 C14.4125,7.115625 14.4562506,7.5515625 14.4562506,7.9875 C14.4578125,11.5453125 11.5625,14.440625 8.0046875,14.440625 Z",
    id: "\\u8DEF\\u5F84",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3421875,4.6828125 L9.146875,4.6828125 C8.790625,4.6828125 8.5015625,4.39375 8.5015625,4.0375 C8.5015625,3.68125 8.790625,3.3921875 9.146875,3.3921875 L13.340625,3.3921875 C13.696875,3.3921875 13.9859375,3.68125 13.9859375,4.0375 C13.9859375,4.39375 13.6984375,4.6828125 13.3421875,4.6828125 L13.3421875,4.6828125 Z",
    id: "\\u8DEF\\u5F84",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.953125,6.5421875 C11.7875,6.5421875 11.6234375,6.4796875 11.496875,6.353125 C11.2453125,6.1015625 11.2453125,5.6921875 11.496875,5.440625 L12.9,4.0375 L11.496875,2.634375 C11.2453125,2.3828125 11.2453125,1.9734375 11.496875,1.721875 C11.7484375,1.4703125 12.1578125,1.4703125 12.409375,1.721875 L14.26875,3.58125 C14.3890625,3.7015625 14.4578125,3.8671875 14.4578125,4.0375 C14.4578125,4.209375 14.3890625,4.3734375 14.26875,4.49375 L12.409375,6.353125 C12.284375,6.4796875 12.11875,6.5421875 11.953125,6.5421875 L11.953125,6.5421875 Z",
    id: "\\u8DEF\\u5F84",
    fill: "currentColor"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlyRefund);
export default __webpack_public_path__ + "static/media/onlyRefund.2292304a.svg";
export { ForwardRef as ReactComponent };